﻿import { VchalanDetail } from './VchalanDetail';
import { Vchalan } from './Vchalan';
export class Challan {
	public challan: Vchalan | undefined;
	public challandetail: VchalanDetail[] = [];
}
